import React, { useState } from "react";
import { useObserver } from "mobx-react-lite";
import { TextField } from "@material-ui/core";
import { BaseModal } from "Components/Modal/BaseModal";
import { CancelButton } from "Globals/Styles/Control/Buttons";
import { Button } from "@material-ui/core";
import { Cell, Grid, useRouter } from "@shoothill/core";
import { DarwinDateSelect } from "Components/DateSelect/DarwinDateSelect";
import { AddEditResponseViewModel } from "./AddEditResponseViewModel";
import { ReportModalStyle } from "Views/Project/Modals/Modal.Styles";
import { DarwinSelect } from "Components/AutoComplete/DarwinSelect";
import { RFICreateFormViewModel } from "../../Forms/Create/RFICreateFormViewModel";

interface ICreatedModalProps {
    open?: boolean;
    onClose(): void;
    rFIId: string | null;
    id: string | null;
}

export const AddEditResponseView: React.FC<ICreatedModalProps> = (props) => {
    const { match } = useRouter();
    const { projectid } = match.params as any;
    const { open, onClose, rFIId, id } = props;
    const [viewModel] = useState(() => new AddEditResponseViewModel(projectid, rFIId, id));
    const [rfiCreateFormViewModel] = useState(() => new RFICreateFormViewModel(projectid));
    const COLUMNS8 = "1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr";

    const onSave = () => {
        let promise = viewModel.upsert();
        promise.then((response) => {
            if (response.wasSuccessful) {
                onClose();
            }
        });
    };

    return useObserver(() => (
        <BaseModal
            open={open}
            onClose={onClose}
            title={viewModel.hasId ? "Edit response" : "Add response"}
            PaperComponent={ReportModalStyle}
            actions={
                <>
                    <Button onClick={onSave} color="secondary" autoFocus variant="contained">
                        {viewModel.hasId ? "Update" : "Add"}
                    </Button>
                    <CancelButton onClick={onClose}>Cancel</CancelButton>
                </>
            }
        >
            <Grid columnGap={30} rowGap={20} tc={COLUMNS8} dc={COLUMNS8} mb="35px">
                <Cell ts={8} ds={8}>
                    <TextField
                        id="note-textarea"
                        multiline
                        minRows={5}
                        value={viewModel.getValue("comment")}
                        onChange={(event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => viewModel.setValue<string>("comment", event.target.value)}
                        fullWidth
                        className="textarea-forminput"
                        label="Response:"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        placeholder={`Please add`}
                        disabled={false}
                        error={viewModel.getError("comment") !== ""}
                        helperText={viewModel.getError("comment")}
                        onBlur={() => viewModel.isFieldValid("comment")}
                    />
                </Cell>
                <Cell ts={2} ds={2}>
                    <DarwinDateSelect
                        displayName="Date received:"
                        execute={(value: string | null) => viewModel.setReceivedDate(value)}
                        onBlur={() => viewModel.isFieldValid("receivedDate")}
                        placeholder="Please select"
                        validationMessage={viewModel.getError("receivedDate")}
                        value={viewModel.getValue("receivedDate")}
                        canExecute={!viewModel.isFormDisabled && !viewModel.IsLoading}
                    />
                </Cell>
                <Cell ts={2} ds={2}>
                    <TextField
                        type="text"
                        value={viewModel.getValue("fromText")}
                        onChange={(event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => viewModel.setValue<string>("fromText", event.target.value)}
                        fullWidth
                        error={viewModel.getError("fromText") !== ""}
                        disabled={viewModel.IsLoading}
                        label={"From:"}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        placeholder={"Please add"}
                        helperText={viewModel.getError("fromText")}
                    />
                </Cell>
                <Cell ts={2} ds={2}>
                    <DarwinSelect
                        displayName="Status:"
                        execute={(data: any) => viewModel.handleStatusId(data)}
                        fullWidth={true}
                        getOptionLabel={(option: any) => option.displayName}
                        options={rfiCreateFormViewModel.statuses}
                        placeholder="Please select"
                        value={viewModel.status}
                        canExecute={!viewModel.IsLoading}
                        onBlur={() => viewModel.isFieldValid("statusId")}
                        error={viewModel.getError("statusId") !== ""}
                        validationMessage={viewModel.getError("statusId")}
                    />
                </Cell>
            </Grid>
        </BaseModal>
    ));
};
